// import React from "react";
// import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
// import { IoLogoFacebook } from "react-icons/io5";
// import { MdCall } from "react-icons/md";
// import { IoIosMail } from "react-icons/io";
// import "./StaticFooterCSS.css";
// import { RiRegisteredLine } from "react-icons/ri";
// const Footer2 = () => {
//   return (
//     <div className="footermaindiv">
//       <div className="footerdiv">
//         <div className="footeregraddiv">
//           <h4 className="footerTitleColor2">eGRADTutor<sup><RiRegisteredLine /></sup></h4>
//           {/* <p className="">
//             eGRADTutor started with a team of graduates from IIT/IISc.We are
//             experts in training students for UG, PG, MBA and CA entrance
//             examinations.
//           </p> */}
//           <div className="footerlinksdiv footerterms ">
//               <a href="/terms">Terms and Conditions</a> 
//               <a href="/policy">Privacy Policy</a>
//             <a href="/CancellationRefundPolicy">Pricing & Refund Policy</a>
//             {/* <a href="#">Frequently Asked Questions</a> */}
//           </div>
//         </div>
//         <div className="footerlinksdiv footercontact">
//             <div className="footerlinksdiv1">
//               <MdCall />
//               <a style={{ fontWeight: "normal" }} href="tel:+917993270532" >+91-7993270532</a>
//             </div>
//             <div className="footerlinksdiv1">
//               <IoIosMail />
//               <a style={{ fontWeight: "normal" }} href="mailto:contact@egradtutor.in">contact@egradtutor.in</a>
//             </div>
//           </div>

//         <div className="footeregraddiv  footeregradcontactus">
//           {/* <h4 className="footerTitleColor2">Contact Us</h4> */}
//           <div className="">
//             <p className="footerTitleCorporate">Address 
// </p>
//             <div className="addressdiv">
//             <p>
//               eGRADTutor
//               </p> 
//               <p>R.K Nivas,2<sup>nd</sup> Floor,Shivam Road,</p>
//               <p>New Nallakunta, Hyderabad - 500044.</p>
//             </div>
//           {/* <p className="address-line">
//       ,
//     </p> */}
//           </div>
        
         
//         </div>
        
//       </div>
 
//       <div className="footerCopyright">
//       <div className="footeregradfollowus">
//           <div className="footericonsdiv">
//             <a href='https://www.youtube.com/@eGRADTutor'>
//               <IoLogoFacebook />
//             </a>
//             <a  href='https://www.youtube.com/@eGRADTutor'>
//               <FaInstagram />
//             </a>
//             <a FaYoutube href='https://www.youtube.com/@eGRADTutor'>
//               <FaLinkedin />
//             </a>
//             <a href="https://www.youtube.com/@eGRADTutor">
//               <FaYoutube />
//             </a>
//           </div>
//         </div>
//         <div className="copyrightdiv">
//             <p>Copyright © 2025 eGRADTutor. All rights reserved</p>
//         </div>
       
//       </div>
//     </div>
//   );
// };
 
// export default Footer2;
import React from "react";
import { FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { IoLogoFacebook } from "react-icons/io5";
import { MdCall, MdEmail, MdLocationOn } from "react-icons/md";
import "./StaticFooterCSS.css";
import { RiRegisteredLine } from "react-icons/ri";

const LandingPageFooter = () => {
  return (
    <footer className="landing-footer-new">
      <div className="lfn-container">
        <div className="lfn-grid">
          {/* Column 1: Brand */}
          <div className="lfn-brand-col">
            <h2 className="lfn-logo">e<span>GRAD</span>Tutor<sup><RiRegisteredLine /></sup></h2>
            <p className="lfn-brand-desc">
              Prepare for India's top PG entrance examinations with confidence.
            </p>
            <div className="lfn-socials">
              <a href="https://www.youtube.com/@eGRADTutor" target="_blank" rel="noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
              <a href="https://www.instagram.com/egradtutor/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="lfn-links-col">
            <h3 className="lfn-heading">QUICK LINKS</h3>
            <ul className="lfn-list">
              {/* <li><a href="/">Home</a></li>
              <li><a href="/aboutUs">About</a></li> */}
              <li><a href="/terms">Terms and Conditions</a></li>
              <li><a href="/policy">Privacy Policy</a></li>
              <li><a href="/CancellationRefundPolicy">Pricing & Refund Policy</a></li>
            </ul>
          </div>

          {/* Column 3: Contact Us */}
          <div className="lfn-contact-col">
            <h3 className="lfn-heading">CONTACT US</h3>
            <ul className="lfn-list">
              <li>
                <MdCall className="lfn-icon" />
                <a href="tel:+917993270532">+91-7993270532</a>
              </li>
              <li>
                <MdEmail className="lfn-icon" />
                <a href="mailto:contact@egradtutor.in">contact@egradtutor.in</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Address */}
          <div className="lfn-address-col">
            <h3 className="lfn-heading">ADDRESS</h3>
            <ul className="lfn-list lfn-address-list">
              <li>
                <MdLocationOn className="lfn-icon lfn-icon-location" />
                <span>
                  eGRADTutor<br/>
                  R.K Nivas, 2nd Floor, Shivam Road, New Nallakunta, Hyderabad - 500044
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="lfn-bottom">
          <p className="lfn-copyright">© 2026 All rights reserved by <strong>eGRADTutor</strong></p>
          <p className="lfn-credits">Designed & Developed by <strong>nDMatrix.ai Private Limited</strong></p>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
